import { MainLayout } from '../layouts/MainLayout'
import ChatInterface from '../components/chat'
import { SEO } from '../components/SEO/SEO'
import { useAuth } from '../hooks/auth/useAuth'

export const Index = () => {
  const { user } = useAuth()

  const seoConfig = {
    title: user
      ? 'Et Ai Dashboard - Your Personal AI Research Assistant'
      : 'Et Ai - Factually Accurate AI Research Assistant',
    description:
      'Revolutionary AI tool that guarantees factually accurate scientific information backed by peer-reviewed literature. Eliminate hallucinations in academic research.',
    keywords:
      'AI research, academic AI, factual AI, peer-reviewed research, scientific AI, hallucination-free AI, research assistant, academic tool',
    url: 'https://etai.app/',
    canonical: 'https://etai.app/',
    schema: {
      '@context': 'https://schema.org',
      '@type': 'WebApplication',
      name: 'Et Ai',
      description:
        'Factually accurate AI research assistant that eliminates hallucinations by using only peer-reviewed scientific literature',
      url: 'https://etai.app',
      applicationCategory: 'EducationApplication',
      operatingSystem: 'Web',
      offers: {
        '@type': 'Offer',
        price: '0',
        priceCurrency: 'USD',
      },
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        ratingCount: '127',
      },
      provider: {
        '@type': 'Organization',
        name: 'Et Ai Labs',
        url: 'https://etai.app',
      },
    },
  }

  return (
    <MainLayout>
      <SEO {...seoConfig} />
      <ChatInterface />
    </MainLayout>
  )
}
